export default "__VITE_ASSET__DUv7sVOP__"